<template lang="html">
  <v-layout column class="event">
    <chat-user-header main-icon="directions"
                      :event="event"
                      :company-name="resolvedCompanyName"
                      :participants="participants">
      commented
    </chat-user-header>
    <v-flex xs12 sm12 class="text-xs-left event-line ml-1" align-center>
        <span class="pl-4 font-weight-light">{{event.message}}</span>
    </v-flex>
    <v-flex xs12 sm2 v-if="showTime"
            class="text-sm-right text-sm-left event-line font-weight-light caption pr-2">
      <span>{{event.timestamp | formatDate}}</span>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import ChatUserHeader from './ChatUserHeader';

export default {
  name: 'LoadingChuteInstructionsEvent',
  components: {
    ChatUserHeader,
  },
  props: {
    event: {
      required: true,
      type: Object,
    },
    participants: {
      required: true,
      type: Array,
    },
    showTime: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    participant() {
      return this.participants.find(p => p.userId === this.event.userId);
    },
    userCompanyName() {
      return _.get(this.participant, 'organizationName');
    },
    userDisplayName() {
      return this.event.userDisplayName;
    },
    isChuteLocationMessage() {
      return this.event.userId.startsWith('LoadingChuteLocation');
    },
    resolvedUserDisplayName() {
      return this.userDisplayName;
    },
    resolvedCompanyName() {
      return this.isChuteLocationMessage ?
        `${this.userCompanyName} ${this.$t('company-profile.load-chute')}` :
        this.userCompanyName;
    },
  },
};
</script>
<style lang="css" scoped>
  .event {
    border-left: 3px #bf4e30 solid;
  }
</style>



// WEBPACK FOOTER //
// src/components/timeline/LoadingChuteInstructionsEvent.vue